function EmployeeWeekCard({
    week
}) {

    return (
        <>
            <table className="table table-hover ">
                <thead>
                    <tr scope="row">
                        {
                            week.map((weekDay, index) => {
                                return <th key={index} scope="col" className={`col-1 ${weekDay.slots.length == 0 && "opacity-25"}`}>{weekDay.day}</th>
                            })
                        }
                    </tr>
                </thead>
                <tbody>
                    <tr scope="row" >
                        {
                            week.map((weekDay, index) => {
                                return <td key={index} scope="col" className={`col-1 ${weekDay.slots.length == 0 && "opacity-25"}`}>{
                                    weekDay.slots.map((slot, index) => {
                                        return <div key={index}>{slot.start} - {slot.end}<br/></div>
                                    })
                                }</td>
                            })
                        }
                    </tr>
                </tbody>
            </table>

        </>
    )
}

export default EmployeeWeekCard